<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';

	interface Props {
		title?: string | undefined;
		class?: string;
	}

	let { title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} width="60" height="60" viewBox="0 0 60 60" {...rest}>
	<path
		d="M44.3901 19.9337C45.2157 20.7816 45.1976 22.1383 44.3497 22.9639L26.9007 39.9537C26.0778 40.7549 24.7695 40.7649 23.9345 39.9763L15.6692 32.1701C14.8088 31.3575 14.77 30.0013 15.5826 29.1409C16.3952 28.2805 17.7514 28.2418 18.6118 29.0544L25.3832 35.4495L41.3599 19.8933C42.2078 19.0677 43.5645 19.0858 44.3901 19.9337Z"
		fill="#34D399"
	/>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60ZM30 55.7143C44.2016 55.7143 55.7143 44.2016 55.7143 30C55.7143 15.7984 44.2016 4.28572 30 4.28571C15.7984 4.28572 4.28571 15.7984 4.28571 30C4.28571 44.2016 15.7984 55.7143 30 55.7143Z"
		fill="#34D399"
	/>
</SvgWrapper>
